import { useState } from "react";
import Win10Card from "../Win10Card";
import MateriaalToevoegenModal from "../modals/MateriaalToevoegenModal";

export default function MaterialenCard({ werkbon, financial, onRefresh }) {
  const [modalOpen, setModalOpen] = useState(false);
  const materialen = Array.isArray(financial?.materialEntries) ? financial.materialEntries : [];

  return (
    <>
      <Win10Card title="Materialen">
        <div className="space-y-2">
          {materialen.length > 0 ? (
            materialen.map((m, i) => (
              <div key={i} className="border-b py-2 flex justify-between text-sm">
                <div>
                  <p className="font-medium">{m.description || "-"}</p>
                  {m.articleCode ? (
                    <p className="text-xs text-gray-500">Art.nr: {m.articleCode}</p>
                  ) : null}
                  {(m.supplier || m.supplierArticleNumber) && (
                    <p className="text-xs text-gray-500">
                      {[m.supplier, m.supplierArticleNumber].filter(Boolean).join(" • ")}
                    </p>
                  )}
                </div>
                <p className="text-gray-700">
                  {Number(m.qty || 0)} {m.unit || "st"}
                </p>
              </div>
            ))
          ) : (
            <p className="text-gray-500">Nog geen materialen toegevoegd.</p>
          )}

          <button
            onClick={() => setModalOpen(true)}
            className="bg-blue-600 text-white px-3 py-2 mt-2 rounded"
          >
            + Materiaal toevoegen
          </button>
        </div>
      </Win10Card>

      {modalOpen && (
        <MateriaalToevoegenModal
          werkbonId={werkbon._id}
          onClose={() => setModalOpen(false)}
          onSave={() => {
            setModalOpen(false);
            onRefresh?.();
          }}
        />
      )}
    </>
  );
}
